import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

function get_base_trail(meta) {
  const trail = [];

  if (meta.branch === 'configure') {
    trail.push({
      label: "Configure Company Management",
      path: "/configure_company_management",
    });
  } else {
    trail.push({
      label: "Company Management",
      path: "/company_management",
    });

    if (meta.branch === 'overview') {
      trail.push({
        label: "Overview",
        path: "/overview",
      });
    }
  }

  return trail;
}

function has_tabs(meta) {
  return meta.isTab || meta.isDynamic;
}

function handle_tabs(meta, label, new_path, trail) {
  if (meta.isTab) {
    sessionStorage.setItem(
      'active_tab',
      JSON.stringify({ label, path: new_path })
    );
    sessionStorage.setItem('breadcrumb_history', '[]');
  }

  const saved_tab = JSON.parse(sessionStorage.getItem('active_tab'));
  if (saved_tab) {
    trail.push(saved_tab);
  }
}

function handle_dynamic_steps(meta, label, new_path, trail) {
  if (!meta.isDynamic) return;

  let history = JSON.parse(
    sessionStorage.getItem('breadcrumb_history') || '[]'
  );

  const index = history.findIndex(item => item.path === new_path);

  history =
    index !== -1
      ? history.slice(0, index + 1)
      : [...history, { label, path: new_path }];

  sessionStorage.setItem(
    'breadcrumb_history',
    JSON.stringify(history)
  );

  trail.push(...history);
}

function finalize_trail(trail) {
  return trail.length > 1 ? trail : [];
}

export default {
  name: "BreadCrumbs",
  setup() {
    const route = useRoute();
    const trail = ref([]);

    watch(
      () => route.path,
      (new_path) => {
        const meta = route.meta || {};
        const label = meta.breadcrumb || 'Page';

        let new_trail = get_base_trail(meta);

        if (has_tabs(meta)) {
          handle_tabs(meta, label, new_path, new_trail);
        }

        handle_dynamic_steps(meta, label, new_path, new_trail);

        trail.value = finalize_trail(new_trail);
      },
      { immediate: true }
    );
 
    const break_crumbs = { breadcrumbs: trail };
    return break_crumbs;
  }
};
